import * as React from "react";
import "./Grid.sass"
import PropTypes from "prop-types";

export default function SimpleGrid(props) {
    const {style} = props

    return (
        <div className="grid-wrapper" style={style}>
            {props.children}
        </div>
    )
}

SimpleGrid.propTypes = {
    style: PropTypes.object
}